import React from "react";
import { ResponsiveHeroImage, LazyLoadImages } from "@quintype/components";
import { Author } from "../../basic/author";
import get from "lodash/get";
import "./vertical-story.module.css";
import PropTypes from "prop-types";
import TimeAgo from "react-timeago";
import { formatter } from "../../../utils";
import { ImageFallback } from "../../../components/basic/image-fallback";
import { SvgHandler } from "../../svg-handler/svg-handler";
import dotIcon from "../../../../assets/icons/dot.svg";

function VerticalStory({ story, config, eager = false }) {
  const author = {
    name: get(story, ["authors", 0, "name"], story["author-name"]),
    id: get(story, ["authors", 0, "id"], story["author-id"])
  };
  const date = get(story, ["last-published-at"], story["first-published-at"]);

  return (
    <div styleName="vertical-story-wrapper">
      <div data-testid="vertical-img-wrapper" styleName="image-wrapper">
        {story["hero-image-s3-key"] ? (
          <figure styleName={`hero-image ${story["story-template"] === "video" ? "video-icon" : ""}`}>
            <LazyLoadImages margin={"0px"}>
              <ResponsiveHeroImage
                story={story}
                defaultWidth={480}
                aspectRatio={[4, 3]}
                widths={[100, 250]}
                sizes="(max-width: 500px) 20%, (max-width: 768px) 23vw, 10%"
                imgParams={{ auto: ["format", "compress"], fit: "max" }}
                eager={eager}
              />
            </LazyLoadImages>
          </figure>
        ) : (
          <ImageFallback styleName="image--cover" story={story} />
        )}
      </div>
      <div styleName="content-wrapper">
        <h2 data-testid="vertical-headline" styleName="headline" dangerouslySetInnerHTML={{ __html: story.headline }} />
        <div data-testid="vertical-author" styleName="create-at">
          <Author author={author} config={config} />
          {date && story["author-name"] ? (
            <SvgHandler xlinkHref={dotIcon} clazzName="dot" width="3px" height="3px" />
          ) : null}
          <div styleName="post-time">
            <TimeAgo
              date={date}
              formatter={(value, unit, suffix, date) => formatter(value, unit, suffix, date)}
              title={null}
            />
          </div>
        </div>
        <p
          data-testid="vertical-subheadline"
          styleName="sub-headline"
          dangerouslySetInnerHTML={{ __html: story.subheadline }}
        />
      </div>
    </div>
  );
}

VerticalStory.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  eager: PropTypes.bool
};
export { VerticalStory };
